export default {
  state: {
    rsvpInTable: [],
    fetching: false,
    noDataFound: false,
    checkedReservations: [],
    rsvpPaging: {
      currentPage: 1,
      pageSize: 20,
      totalPages: 0
    },
    totalItem: 0,
    lastSync: '',
    rsvpSort: {
      order: 'cb.pickupTime',
      asc: true
    },
    readyToGo: {
      show: false,
      id: 0,
      loading: false,
      success: false
    },
    notes: {
      show: false,
      message: '',
      loading: false,
      success: false
    },
    filter: {
      services: []
    }
  },
  mutations: {
    setRsvpInTable (state, rsvps) {
      state.rsvpInTable = rsvps
      state.checkedReservations = []
    },
    pushRsvpInTable (state, rsvp) { state.rsvpInTable.push(rsvp) },
    addRsvpInTable (state, rsvp) { state.rsvpInTable.unshift(rsvp) },
    removeRsvpInTable (state, rsvp) {
      if (state.rsvpInTable.length <= 0) {
        return
      }
      let rsvps = state.rsvpInTable
      state.rsvpInTable = rsvps.filter(
        item => item.id !== rsvp.id || item.isPackage !== rsvp.isPackage)

      // remove from selected
      let checkedReservations = state.checkedReservations
      state.checkedReservations = checkedReservations.filter(
        item => item.id !== rsvp.id || item.isPackage !== rsvp.isPackage)
    },
    setFetching (state, value) { state.fetching = value },
    setNoDataFound (state, value) { state.noDataFound = value },
    updateCheckedReservations (state, value) { state.checkedReservations = value },
    clearCheckedRsvps (state) { state.checkedReservations = [] },

    // Paging state
    setRsvpCurrentPage (state, value) { state.rsvpPaging.currentPage = value },
    setRsvpTotalPages (state, totalItems) { state.rsvpPaging.totalPages = Math.ceil(totalItems / state.rsvpPaging.pageSize) },
    resetRsvpPaging (state) {
      state.rsvpPaging = {
        currentPage: 1,
        pageSize: 20,
        totalPages: 0
      }
    },

    // Sorting
    setRsvpSort (state, value) { state.rsvpSort = value },
    setRsvpSortingOrder (state, value) { state.rsvpSort.order = value },
    setRsvpSortingAsc (state, value) { state.rsvpSort.asc = value },
    resetRsvpSorting (state) {
      state.rsvpSort = {
        order: 'cb.pickupTime',
        asc: 1
      }
    },
    setReadyToGoShow (state, value) { state.readyToGo.show = value },
    setReadyToGoID (state, value) { state.readyToGo.id = value },
    setReadyToGoLoading (state, value) { state.readyToGo.loading = value },
    setReadyToGoSuccess (state, value) { state.readyToGo.success = value },
    setFilterService (state, value) { state.filter.services = value },
    setNotesShow (state, value) {state.notes.show = value },
    setNotesMessage (state, value) {state.notes.message = value },
    setDispatchTotal (state, value) { state.totalItem = value },
    setLastSync (state, value) { state.lastSync = value },
    setPendingOffer (state, data) {
      let i = state.rsvpInTable.findIndex(x => x.id === data.id)
      if (i > -1) {
        state.rsvpInTable[i].pendingOffer = {
          show: data.show,
          timer: data.timer
        }
      }
    },
    updateRsvpStatus (state, data) {
      let i = state.rsvpInTable.findIndex(x => x.id === data.id)
      if (i > -1) {
        state.rsvpInTable[i].status = data.status
        state.rsvpInTable[i].statusClass = data.statusClass
        state.rsvpInTable[i].resStatus = data.resStatus
      }
    }
  },
  sharedMutations: [
    /*
    'dispatch/setRsvpInTable',
    'dispatch/addRsvpInTable',
    'dispatch/removeRsvpInTable',
    'dispatch/setFetching',
    'dispatch/setNoDataFound',
    'dispatch/updateCheckedReservations'
    */
  ]
}



// WEBPACK FOOTER //
// ./src/store/dispatch/dispatch-reservations.js